"use client";

import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Globe } from "lucide-react";

export default function ContactPage() {
  return (
    <main className="min-h-screen pt-32 px-6 mb-12 md:px-12 max-w-7xl mx-auto bg-background">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-32 items-center">
        
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          className="flex flex-col space-y-8"
        >
          <div>
            <p className="text-fd-500 font-black tracking-[0.3em] mb-4 uppercase text-xs">Contact Information</p>
            <h1 className="text-6xl md:text-8xl font-bold uppercase leading-[0.9]">
              LET'S <br />
              <span className="text-fd-500">CONNECT.</span>
            </h1>
          </div>
          
          <p className="md:text-lg font-medium max-w-sm leading-relaxed">
            ยินดีให้คำปรึกษาด้านการพัฒนาระบบซอฟต์แวร์, เว็บไซต์, แอปพลิเคชัน และโซลูชันไอทีอื่นๆ  
            ติดต่อเราได้ทุกช่องทางที่สะดวก
          </p>

          <div className="w-24 h-1 bg-fd-500 rounded-full" />
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          className="space-y-6"
        >
          <div className="group p-8 rounded-[2rem] bg-secondary/30 border border-border transition-all hover:bg-secondary/50">
            <div className="flex items-start space-x-6">
              <div className="p-4 bg-background rounded-2xl text-fd-500 shadow-sm">
                <MapPin size={28} />
              </div>
              <div className="space-y-2">
                <h3 className="text-xs font-black tracking-widest text-muted-foreground uppercase">Location</h3>
                <p className="md:text-lg font-medium leading-relaxed">
                  159/113 หมู่ที่ 2 <br />
                  ตำบลบ้านเกาะ <br />
                  อ.พระนครศรีอยุธยา <br />
                  จ.พระนครศรีอยุธยา 13000
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <a href="tel:0801234567" className="group p-8 rounded-[2rem] bg-secondary/30 border border-border transition-all hover:border-fd-500/50">
              <div className="flex flex-col space-y-4">
                <Phone className="text-fd-500" size={28} />
                <div>
                  <h3 className="text-xs font-black tracking-widest text-muted-foreground uppercase mb-1">Call Us</h3>
                  <p className="md:text-lg font-medium">081-555-3558</p>
                </div>
              </div>
            </a>

            <a href="mailto:folda.info@gmail.com" className="group p-8 rounded-[2rem] bg-secondary/30 border border-border transition-all hover:border-fd-500/50">
              <div className="flex flex-col space-y-4">
                <Mail className="text-fd-500" size={28} />
                <div>
                  <h3 className="text-xs font-black tracking-widest text-muted-foreground uppercase mb-1">Email</h3>
                  <p className="md:text-lg font-medium">folda.info@gmail.com</p>
                </div>
              </div>
            </a>
          </div>

          <div className="p-8 rounded-[2rem] border border-dashed border-border flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Globe size={20} className="text-muted-foreground" />
              <span className="md:text-lg font-medium">www.folda.co.th</span>
            </div>
            <div className="flex space-x-4">
            </div>
          </div>
        </motion.div>

      </div>
    </main>
  );
}